import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `expo-local-authentication`: biometrics read as unsupported,
 * so Settings hides the toggle and the lock screen never prompts.
 */
export default {
    authenticate: unavailableOnWeb('FingerprintScanner.authenticate'),
    isSensorAvailable: unavailableOnWeb('FingerprintScanner.isSensorAvailable'),
    release: () => { },
};
